import type { UrlTargeting } from '@openx/types/targeting/domains';

export const applyUrlTargeting = ({
  type,
  urls,
  inventorylist_id,
  domain_targeting_option,
  domain_app_inventory_operator,
}: UrlTargeting): UrlTargeting | null => {
  if (!inventorylist_id && !urls?.length) {
    return null;
  }

  const updatedTargetingParams: UrlTargeting = {
    type,
    domain_targeting_option,
  };

  updatedTargetingParams.urls = urls?.length ? urls : null;

  if (inventorylist_id !== undefined) {
    updatedTargetingParams.inventorylist_id = inventorylist_id ? inventorylist_id : null;
  }

  if (domain_app_inventory_operator !== undefined) {
    updatedTargetingParams.domain_app_inventory_operator = domain_app_inventory_operator ?? null;
  }

  return updatedTargetingParams;
};
